var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookieIconDarkTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cookie_Icon",
    "data-name": "Cookie Icon",
    transform: "translate(-1491 -340)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(1491 340)",
    fill: "rgba(255,255,255,0.08)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1503 352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(11.863 27.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M133.61,294.8a3.327,3.327,0,1,0-3.326,3.326A3.327,3.327,0,0,0,133.61,294.8Z",
    transform: "translate(-126.956 -291.475)",
    fill: "rgba(255,255,255,0.24)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(24.464 31.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M271.087,342.935a4.461,4.461,0,1,0-4.463,4.46A4.463,4.463,0,0,0,271.087,342.935Z",
    transform: "translate(-262.165 -338.472)",
    fill: "rgba(255,255,255,0.24)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(15.27 8.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M168.938,95.21a2.808,2.808,0,1,0-2.808,2.805A2.808,2.808,0,0,0,168.938,95.21Z",
    transform: "translate(-163.323 -92.402)",
    fill: "rgba(255,255,255,0.24)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M24,48a7.835,7.835,0,0,1-3.768-1.164,10.4,10.4,0,0,0-2.109-.9,10.367,10.367,0,0,0-2.278-.272A7.834,7.834,0,0,1,12,44.784a7.832,7.832,0,0,1-2.683-2.892,10.363,10.363,0,0,0-1.373-1.835,10.384,10.384,0,0,0-1.835-1.373A7.827,7.827,0,0,1,3.216,36a7.836,7.836,0,0,1-.878-3.844,10.4,10.4,0,0,0-.273-2.278,10.368,10.368,0,0,0-.9-2.107A7.84,7.84,0,0,1,0,24a7.834,7.834,0,0,1,1.162-3.765,10.37,10.37,0,0,0,.9-2.111,10.4,10.4,0,0,0,.273-2.278A7.846,7.846,0,0,1,3.216,12,7.814,7.814,0,0,1,6.108,9.316,10.358,10.358,0,0,0,7.944,7.944,10.365,10.365,0,0,0,9.317,6.108,7.814,7.814,0,0,1,12,3.216a7.844,7.844,0,0,1,3.844-.878,10.4,10.4,0,0,0,2.277-.273,10.372,10.372,0,0,0,2.112-.9A7.835,7.835,0,0,1,24,0a6.211,6.211,0,0,1,2.477.536.937.937,0,0,1,.533,1.134c-.685,2.273-.456,4.257.644,5.588,1.048,1.267,2.858,1.835,5.1,1.6a.939.939,0,0,1,.975.6,5.378,5.378,0,0,0,3.718,3.517,7.02,7.02,0,0,0,5.933-1.235A.937.937,0,0,1,44.784,12a7.832,7.832,0,0,1,.877,3.845,10.367,10.367,0,0,0,.272,2.278,10.4,10.4,0,0,0,.9,2.109A7.832,7.832,0,0,1,48,24a7.839,7.839,0,0,1-1.165,3.772,10.392,10.392,0,0,0-.9,2.1,10.371,10.371,0,0,0-.272,2.278A7.825,7.825,0,0,1,44.784,36a7.844,7.844,0,0,1-2.892,2.684,10.394,10.394,0,0,0-1.835,1.374,10.394,10.394,0,0,0-1.374,1.835A7.844,7.844,0,0,1,36,44.784a7.823,7.823,0,0,1-3.844.877,10.372,10.372,0,0,0-2.279.272,10.392,10.392,0,0,0-2.1.9A7.839,7.839,0,0,1,24,48ZM24,1.875a6.186,6.186,0,0,0-2.9.951,11.983,11.983,0,0,1-2.489,1.05,12.018,12.018,0,0,1-2.676.335,6.194,6.194,0,0,0-2.994.629A6.164,6.164,0,0,0,10.9,7.118,11.976,11.976,0,0,1,9.27,9.27,11.988,11.988,0,0,1,7.117,10.9,6.165,6.165,0,0,0,4.84,12.936a6.2,6.2,0,0,0-.63,2.994,12.019,12.019,0,0,1-.335,2.678A11.987,11.987,0,0,1,2.826,21.1,6.186,6.186,0,0,0,1.875,24a6.19,6.19,0,0,0,.952,2.907A11.984,11.984,0,0,1,3.876,29.39a12.026,12.026,0,0,1,.335,2.678A6.188,6.188,0,0,0,4.84,35.06,6.177,6.177,0,0,0,7.119,37.1,12.009,12.009,0,0,1,9.27,38.73,11.992,11.992,0,0,1,10.9,40.882a6.182,6.182,0,0,0,2.04,2.278,6.183,6.183,0,0,0,2.992.627,11.981,11.981,0,0,1,2.679.334,12.014,12.014,0,0,1,2.486,1.051,6.186,6.186,0,0,0,2.9.953,6.188,6.188,0,0,0,2.909-.954,12.012,12.012,0,0,1,2.482-1.049,11.985,11.985,0,0,1,2.68-.334,6.175,6.175,0,0,0,2.99-.627,6.194,6.194,0,0,0,2.043-2.28A9.826,9.826,0,0,1,40.881,37.1a6.194,6.194,0,0,0,2.279-2.042,6.174,6.174,0,0,0,.627-2.991,11.985,11.985,0,0,1,.334-2.68,12.011,12.011,0,0,1,1.049-2.482A6.189,6.189,0,0,0,46.125,24a6.184,6.184,0,0,0-.953-2.9,12.017,12.017,0,0,1-1.051-2.486,11.981,11.981,0,0,1-.334-2.679,9.447,9.447,0,0,0-.235-2.038,8.99,8.99,0,0,1-6.595.9,7.1,7.1,0,0,1-4.713-4.014,7.143,7.143,0,0,1-6.036-2.323A7.471,7.471,0,0,1,24.987,2,3.891,3.891,0,0,0,24,1.875Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(25.918 14.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M277.659,160a.957.957,0,1,1-.008-1.914h.008a.957.957,0,0,1,0,1.914Z",
    transform: "translate(-276.698 -158.085)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(16.097 19.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M172.808,208.584a.957.957,0,1,1-.008-1.914h.008a.957.957,0,0,1,0,1.914Z",
    transform: "translate(-171.847 -206.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(7.201 24.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M76.206,268a.957.957,0,0,1-.008-1.914h.008a.957.957,0,0,1,0,1.914Z",
    transform: "translate(-75.245 -266.083)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(39.14 21.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M420.382,234.237a.957.957,0,0,1-.008-1.914h.008a.957.957,0,0,1,0,1.914Z",
    transform: "translate(-419.421 -232.323)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(37.009 30.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M396.06,322.279a.957.957,0,1,1-.008-1.914h.008a.957.957,0,0,1,0,1.914Z",
    transform: "translate(-395.099 -320.365)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(17.106 37.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M183.579,401.194a.957.957,0,1,1-.008-1.914h.008a.957.957,0,0,1,0,1.914Z",
    transform: "translate(-182.618 -399.28)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(30.335 23.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M324.82,250.111h-.011a.957.957,0,0,1,0-1.914h.011a.957.957,0,0,1,0,1.914Z",
    transform: "translate(-323.852 -248.197)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookieIconDarkTheme);
export default __webpack_public_path__ + "static/media/CookieIconDarkTheme.59ae66f7ecd949c8c949a9408096c0a7.svg";
export { ForwardRef as ReactComponent };